import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function wcgwTaskScotsreducer(state = initialstate.wcgwTasksScots, action) {
	switch (action.type) {
		case types.GET_SCOTS_FOR_ASSERTIONIDS:
			return action.response || state;
		default:
			return state;
	}
}
